/**
 * How long each preview holds before the carousel advances.
 *
 * Kept in step with the miniapp's `src/consts/carousel.ts` so the same preset
 * cycles at the same rate on both surfaces.
 */
export const CAROUSEL_INTERVAL_MS = 1800;
